import { render, staticRenderFns } from "./notificationGroupDetails.vue?vue&type=template&id=7709c242&"
import script from "./notificationGroupDetails.vue?vue&type=script&lang=js&"
export * from "./notificationGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports